export default __webpack_public_path__ + "support-hub-for-mobile-app-issues.png";